/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-08-22 11:03:46
 * @version 1.0.0
 */

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { IRootState } from '@src/types';
import { MESSAGE_NAV_KEY } from '@src/utils/constant/common';
import { IconFont, SFCAvatar } from '@src/features/common';
import DefaultAvatar from '@src/assets/default_avatar.png';
import { Tooltip, Button, Dropdown, Menu } from 'antd';
import { SFCFullModel } from '@features/common/components';
import history from '@src/common/history';
import LOGO from '@src/assets/LOGO.png';
import Search from './Search';
import SFCNavigator from './SFCNavigator';
import './SFCHeader.less';
import WriteMenu from './WriteMenu';

type StateProps = ReturnType<typeof mapStateToProps>;

export interface ISFCHeaderProps {
  pathname?: string;
}
type Props = StateProps & ISFCHeaderProps;

export const SFCHeader: React.SFC<Props> = (props: Props) => {
  const { userInfo = {}, pathname = '' } = props;
  const { unreadMessages = 0 } = userInfo;
  const [modelVisiable, setModelVisiable] = useState(false);
  const isDefaultEdit = pathname.indexOf('article/edit') > 0;
  const isMarkdownEdit = pathname.indexOf('article/markdown') > 0;
  const [menuShow, setMenuShow] = useState(false);
  let timeFunc: NodeJS.Timeout | undefined = undefined;
  useEffect(() => {
    setModelVisiable(false);

    return () => {
      timeFunc && clearTimeout(timeFunc);
    };
  }, [pathname, timeFunc, unreadMessages]);

  let headInner: React.ReactNode = (
    <>
      <SFCNavigator />
      <div
        onMouseEnter={() => {
          timeFunc && clearTimeout(timeFunc);
          setMenuShow(true);
        }}
        onMouseLeave={() => {
          timeFunc = setTimeout(() => {
            setMenuShow(false);
          }, 300);
        }}
        className="home-write"
      >
        <IconFont type="icon-bianji" className="mgr-icon" />
        <span>写点东西</span>
        {menuShow && <WriteMenu />}
      </div>

      <div className="search__wrapper">
        <Search />
      </div>

      <div>
        <Link to={`/${MESSAGE_NAV_KEY}/index/0`} className="message">
          {unreadMessages > 0 && <IconFont type="icon-new-info" className="message__new" />}
          <IconFont type="icon-message" />
        </Link>
      </div>
    </>
  );

  const switchModel = (type: string) => {
    if ((type === 'default' && isMarkdownEdit) || (type === 'markdown' && isDefaultEdit)) {
      setModelVisiable(true);
    }
  };

  if (isDefaultEdit || isMarkdownEdit) {
    // headInner = (
    //   <div className="header__tab-mode">
    //     <div className="header__tab__left">
    //       <div className="header__tab__con">
    //         <div
    //           onClick={() => {
    //             switchModel('default');
    //           }}
    //           className={`header__tab-btn ${isDefaultEdit ? 'active' : ''}`}
    //         >
    //           默认编辑器
    //         </div>
    //         <div
    //           onClick={() => {
    //             switchModel('markdown');
    //           }}
    //           className={`header__tab-btn ${isMarkdownEdit ? 'active' : ''}`}
    //         >
    //           Markdown
    //         </div>
    //       </div>
    //       <Tooltip
    //         overlayStyle={{ maxWidth: '360px' }}
    //         title={
    //           <div className="ant-header__tip__txt">
    //             <p className="ant-header__p">小店社区为创作者提供两种编辑模式：</p>
    //             <p className="ant-header__p">
    //               <span className="medium">默认编辑器</span> — —
    //               常规模式编辑器，满足普通用户使用需求
    //             </p>
    //             <p className="ant-header__p">
    //               <span className="medium">Markdown</span> — — 识别Markdown语法，让文档编辑更高效
    //             </p>
    //           </div>
    //         }
    //         placement="bottomLeft"
    //         overlayClassName="ant-tooltip-white"
    //         arrowPointAtCenter
    //       >
    //         <IconFont type="icon-info" className="header__tab__ico" />
    //       </Tooltip>
    //     </div>

    //     {/* <div className="header__tab__right">已保存...</div> */}
    //   </div>
    // );
  }

  const closeModel = () => {
    setModelVisiable(false);
  };

  const doSwitchModel = () => {
    // history.push(isDefaultEdit ? '/article/markdown' : '/article/edit');
    history.push('/article/edit');
  };

  const avaterMenu = (
    <Menu>
      <Menu.Item>
        <NavLink
          activeClassName="active-item"
          to={`/personal/${userInfo.username}`}
          className="item"
        >
          个人页面
        </NavLink>
      </Menu.Item>
      <Menu.Item>
        <NavLink activeClassName="active-item" to="/admin/artList" className="item">
          后台管理
        </NavLink>
      </Menu.Item>
    </Menu>
  );
  return (
    <div className="k-tech-com-header">
      <div className="k-tech-com-header--inner">
        <Link to="/" className="logo__link">
          <img src={LOGO} />
        </Link>
        {headInner}
        {/* {userInfo ? (
          <Link to="/personal" className="link">
            <SFCAvatar className="header__avatar" src={userInfo.photo} />
          </Link>
        ) : (
          <SFCAvatar className="header__avatar" />
        )} */}
        {userInfo ? (
          userInfo.manageBackgroundAdmin ? (
            <Dropdown overlay={avaterMenu}>
              <img className="header__avatar" src={userInfo.photo || DefaultAvatar} />
            </Dropdown>
          ) : (
            <Link to={`/personal/${userInfo.username}`} className="link">
              <SFCAvatar className="header__avatar" src={userInfo.photo} />
            </Link>
          )
        ) : (
          <SFCAvatar className="header__avatar" />
        )}
      </div>

      {modelVisiable && (
        <SFCFullModel onClose={closeModel} title="文章发布">
          <div className="header__confirm">
            <IconFont type="icon-info-2" className="header__icon" />
            <h4 className="header__tit-in">
              确认切换为 {isDefaultEdit ? 'Markdown' : '默认'} 编辑器？
            </h4>
            <p className="header__txt-in">
              切换编辑器后，原编辑内容无法带入到新编辑页，请先 拷贝 或 保存草稿。
            </p>
            <div className="header__opt">
              <Button className="header__opt__left" onClick={closeModel}>
                取消
              </Button>
              <Button type="primary" onClick={doSwitchModel}>
                确认
              </Button>
            </div>
          </div>
        </SFCFullModel>
      )}
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state: IRootState) {
  return {
    userInfo: state.common.userInfo
  };
}

export default connect<StateProps>(mapStateToProps)(React.memo(SFCHeader));
